// 将对象数组转为JSON文件并下载的工具函数
const downloadJson = (data: { [key: string]: unknown }[], fileName: string = 'data.json') => {
  try {
    // 1. 将对象数组转为格式化的JSON字符串（indent=2 美化格式）
    const jsonString = JSON.stringify(data, null, 2);
    // 2. 创建Blob对象（MIME类型为application/json）
    const blob = new Blob([jsonString], { type: 'application/json' });
    // 3. 生成临时下载URL
    const url = URL.createObjectURL(blob);
    // 4. 创建隐藏的a标签并模拟点击
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName; // 下载的文件名（默认data.json）
    document.body.appendChild(a);
    a.click();
    // 5. 清理资源
    document.body.removeChild(a);
    URL.revokeObjectURL(url); // 释放URL对象，避免内存泄漏
  } catch (error) {
    console.error('下载JSON文件失败：', error);
  }
};
export default downloadJson